<template>
  <a-dialog name="legal_notice">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <legal-notice></legal-notice>
    </div>
  </a-dialog>
</template>

<script>
import LegalNotice from '@/views/Common/Documents/LegalNotice'

export default {
  name: 'LegalNoticeDialog',
  components: { LegalNotice }
}
</script>

<i18n>
{
	"en": {
		"title": "Legal Notice"
	},
	"es": {
		"title": "Notas legales"
	},
	"fr": {
		"title": "Mentions Légales"
	},
	"it": {
		"title": "Note legali"
	},
	"pt": {
		"title": "Avisos Legais"
	},
	"pl": {
		"title": "Informacje prawne"
	}
}
</i18n>
